import React from "react";
import './NoSearchResults.scss';

const NoSearchResults = (props) => {
  return (
    <div className="NoSearchResults">
      <h4>We couldn't find any assisted living care facilities matching your search.</h4>
      <strong>Suggestions for improving your search results:</strong>
      <p>
        Try a larger search area by adding more locations.<br />
        Try expanding your monthly price range.<br />
      </p>
    </div>
  );
};

export default NoSearchResults;
